import { get, post } from '../utils/http'

class Camp {
  //获取家研会列表
  async getSeminarList(data) {
    const res = await get('/api/content/v1/seminar/list', data)
    return res.data
  }

  //获取家研会详情
  async getSeminarDetail(id, accessParameter) {
    const res = await get(
      '/api/content/v1/seminar/getDetails?id=' +
        id +
        '&accessParameter=' +
        accessParameter
    )
    return res.data
  }

  //家研会创建订单
  async seminarCreateOrder(data) {
    const res = await post('/api/pay/v1/order/seminar/create', data)
    return res.data
  }

  //家研会支付订单
  async seminarPay(data) {
    const res = await post('/api/pay/v1/order/seminar/pay', data)
    return res.data
  }

  //家研会判断是否购买任何vip
  async seminarVip() {
    const res = await get('/api/pay/v1/cloumnMemberOrder/isColumnVIP')
    return res.data
  }

  //特训营直播内容列表
  async seminarContentList(
    params = {
      seminarId: '',
      type: ''
    }
  ) {
    const res = await get('/api/content/v1/seminarContent/list', params)
    return res.data
  }

  //特训营直播内容详情
  async seminarLiveDetail(
    params = {
      seminarId: '',
      type: ''
    }
  ) {
    const res = await get('/api/content/v1/seminarContent/details', params)
    return res.data
  }

  // 获取特训营分类
  async getLevelCount() {
    const res = await get('/api/content/v1/seminar/getLevel')
    return res.data
  }

  // 根据特训营等级和是否报名获取特训营列表
  async getSeminarListByCate(data) {
    const res = await get('/api/content/v1/seminar/list', data)
    return res.data
  }

  // 使用兑换码
  async seminarGiftCode(code) {
    const res = await get(`/api/content/v1/seminarGiftLog/${code}`)
    return res.data
  }

  //【企业版特训营】加载某特训营学习计划
  async learnPlan(data) {
    const res = await get(`/api/content/v1/seminarContent/initLearnPlan`, data)
    return res.data
  }

  //【企业版特训营】填充某特训营学习计划
  async appendLearnPlan(data) {
    const res = await get(
      `/api/content/v1/seminarContent/appendLearnPlan`,
      data
    )
    return res.data
  }

  //【企业版特训营】打卡学习计划
  async Learnplan(id) {
    const res = await post(`/api/content/v1/clockin/learnPlan/clockIn/${id}`)
    return res.data
  }
  // 特训营章节列表
  async getSeminarKpointListBySeminarId(data) {
    const res = await get(
      `/api/content/v1/seminar/annex/getSeminarKpointListBySeminarId`,
      data
    )
    return res.data
  }
  // 特训营课件列表
  async getSeminarCourseAnnexListBySeminarId(data) {
    const res = await get(
      `/api/content/v1/seminar/annex/getSeminarCourseAnnexListBySeminarId`,
      data
    )
    return res.data
  }
  // 获取章节播放iD
  async getSeminarKopintPlayVideoId(data) {
    const res = await get(
      '/api/content/v1/seminar/annex/getSeminarKopintPlayVideoId',
      data
    )
    return res.data
  }
}

export default new Camp()
